// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"Dialog_actionButton__2tgbs","cancel":"Dialog_cancel__24m1-"};